<form #f="ngForm" (ngSubmit)="editMember()">
    <div class="p-grid">
        <div class="p-col-12 error-notify-text">
            <app-validateform [formToValidate]="editMemberForm"></app-validateform>
        </div>
    </div>
    <p-messages [(value)]="msgs"></p-messages>
    <div>    
        <div class="p-grid">
            <div class="p-col-12 page-header">Edit Office</div>
            <div class="p-col-12 divider-header">
                <p-divider></p-divider>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-2" *ngIf="canEditMember">
                <button pButton type="submit" class="fullwidthbtn" label="Submit"></button>
            </div>
            <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                <button pButton type="button" class="fullwidthbtn" label="Cancel" (click)="cancelEditMember()"></button>
            </div>
        </div>
        <div>
         <p-accordion [multiple]="true">
            <p-accordionTab header="OFFICE NAME AND ADDRESS" [selected]="true">
                <div class="p-grid">
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                            pInputText
                                            [(ngModel)]="member.Name"
                                            name="Name"
                                            requiredNoSpaceValidator
                                            data-display-name="Name" />
                                    <label for="float-input">Name*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="memberTypeOptions"
                                                [(ngModel)]="member.MemberTypeID"
                                                name="MemberType"
                                                required
                                                data-display-name="Member Type"
                                                
                                                >
                                    </p-dropdown>
                                    <label for="dropdown">Member Type</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="officeTypeOptions"
                                                [(ngModel)]="member.OfficeTypeID"
                                                name="OfficeType"
                                                required
                                                data-display-name="Office Type"
                                                (onChange)="onOfficeTypeChange()"
                                                >
                                    </p-dropdown>
                                    <label for="dropdown">Office Type</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="parentOfficeOptions"
                                                [(ngModel)]="member.ParentMemberID"
                                                name="Parent Office"   
                                                [disabled] = "disableParentOfficedDropDown"                                             
                                                >
                                    </p-dropdown>
                                    <label for="dropdown">Parent Office</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="approvingManagerOptions"
                                                [(ngModel)]="member.ManagerID"
                                                name="Approving Manager"
                                                required
                                                data-display-name="Approving Manager"
                                                (onChange)="onChangeAppovingManager()"
                                                >
                                    </p-dropdown>
                                    <label for="dropdown">Approving Manager*</label>
                                </span>
                            </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <p-dropdown inputId="dropdown"
                                            [autoDisplayFirst]="false"
                                            [showClear]="true"
                                            [options]="countryOptions"
                                            [(ngModel)]="member.CountryID"
                                            name="Country"
                                            (onChange)="onCountryChange()">
                                </p-dropdown>
                                <label for="dropdown">Country</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.Address"
                                        name="Address"                                           
                                        data-display-name="Address" />
                                <label for="float-input">Address</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.Address2"
                                        name="Address 2"                                           
                                        data-display-name="Address 2" />
                                <label for="float-input">Address 2</label>
                            </span>
                        </div>

                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.City"
                                        name="City"                                           
                                        data-display-name="City" />
                                <label for="float-input">City</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <p-dropdown inputId="dropdown"
                                            [autoDisplayFirst]="false"
                                            [showClear]="true"
                                            [options]="stateOptions"
                                            [(ngModel)]="member.StateID"
                                            name="State">
                                </p-dropdown>
                                <label for="dropdown">State</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.PostalCode"
                                        name="Zip" />
                                <label for="p-float-label">Zip</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.OfficePhone"
                                        name="OfficePhone"
                                        
                                        data-display-name="OfficePhone" />
                                <label for="float-input">Office Phone*</label>
                            </span>
                        </div>

                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.OfficeFax"
                                        name="OfficeFax"
                                        
                                        data-display-name="OfficeFax" />
                                <label for="float-input">Office Fax</label>
                            </span>
                        </div>

                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.OfficeEmail"
                                        name="OfficeEmail" />
                                <label for="float-input">Office Email</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.OfficeWebsite"
                                        name="OfficeWebsite" />
                                <label for="float-input">Office Website</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <p-message severity="info" text="Check whether the phone numbers are in correct format, which is +country code region code (if applicable) and phone number, for example: +1 XXX XXX XXXX. You must use this format for both domestic and international phone numbers. Your phone number will appear exactly as entered." styleClass="mr-2"></p-message>
                        </div>
                    </div>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab header="SOCIAL MEDIA">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-grid">                
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.FacebookID"
                                        name="FacebookId" />
                                <label for="float-input">Facebook</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.TwitterID"
                                        name="TwitterId" />
                                <label for="float-input">Twitter</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.Instagram"
                                        name="Instagram" />
                                <label for="float-input">Instagram</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.YoutubeID"
                                        name="YoutubeId" />
                                <label for="float-input">Youtube</label>
                            </span>
                        </div>
                        <div class="p-col-12 p-lg-6 p-md-6">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.LinkedInUrl"
                                        name="LinkedInUrl" />
                                <label for="float-input">LinkedIn</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.BlogUrl"
                                        name="BlogUrl" />
                                <label for="float-input">Blog Url</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.BlogRSSFeedUrl"
                                        name="BlogRSSFeedUrl" />
                                <label for="float-input">BlogRSSFeed Url</label>
                            </span>
                        </div>
                        <div class="p-col-12">
                            <span class="p-float-label">
                                <input type="text"
                                        pInputText
                                        [(ngModel)]="member.SEOName"
                                        name="SEOName" />
                                <label for="float-input">SEOName</label>
                            </span>
                        </div>
                    </div>
                </div>
            </div> 
        </p-accordionTab>       
        <p-accordionTab header="OFFICE BACKGROUND">
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-grid">          
                        <div class="p-col-12">
                            <p-editor placeholder="Profile"
                                      [(ngModel)]="member.Profile"
                                      [style]="{'height':'200px'}"
                                      name="Profile"></p-editor>                            
                        </div>                         
                   
                        <div class="p-col-12">                        
                            <p-editor placeholder="About Us"
                            [(ngModel)]="member.AboutUs"
                            [style]="{'height':'200px'}"
                            name="AboutUs"></p-editor>                            
                        </div>  
                        <div class="p-col-12">                        
                            <p-editor placeholder="Market Area Description"
                            [(ngModel)]="member.MarketAreaDescription"
                            [style]="{'height':'200px'}"
                            name="MarketAreaDescription"></p-editor>                            
                        </div>         
                        <div class="p-col-12">                        
                            <p-editor placeholder="Professional Designations"
                            [(ngModel)]="member.ProfessionalDesignations"
                            [style]="{'height':'200px'}"
                            name="ProfessionalDesignations"></p-editor>                            
                        </div>                      
                        <div class="p-col-12">                        
                            <p-editor placeholder="Brokerage Services"
                            [(ngModel)]="member.BrokerageServices"
                            [style]="{'height':'200px'}"
                            name="BrokerageServices"></p-editor>                            
                        </div>
                        <div class="p-col-12">                        
                            <p-editor placeholder="Other Services"
                            [(ngModel)]="member.OtherServices"
                            [style]="{'height':'200px'}"
                            name="OtherServices"></p-editor>                            
                        </div>                  
                        <div class="p-col-12">                        
                            <p-editor placeholder="Exclusivity Area"
                            [(ngModel)]="member.ExclusivityArea"
                            [style]="{'height':'200px'}"
                            name="ExclusivityArea"></p-editor>                            
                        </div>     
                    </div>                   
                    
                </div>
            </div>          
        </p-accordionTab> 
        <p-accordionTab header="MEMBER IMAGES">
            <div class="p-grid">              
                <div class="p-col-12">
                    <div class="message-header">Current Logo</div>
                    <img [src]="member.Logo" width="450" />
                </div>
                <div class="p-col-12">                   
                    <p-fileUpload name="mylogo"
                            url="{{uploadURLLogo}}"
                            accept="image/*"
                            multiple="single"
                            chooseLabel="Change Logo"
                            [showUploadButton]="false"
                            (onBeforeUpload)="onBeforeUploadLogo($event)"
                            (onUpload)="onUploadCompletedLogo($event)">
                     </p-fileUpload>
                </div>
            </div>
            <div class="p-col-12">
                <div class="message-header">Current Icon</div>
                <img width="50" height="50" [src]="member.Icon" />
            </div>
            <div class="p-col-12">                   
                <p-fileUpload name="myicon"
                        url="{{uploadURLIcon}}"
                        accept="image/*"
                        multiple="single"
                        chooseLabel="Change Icon"
                        [showUploadButton]="false"
                        (onBeforeUpload)="onBeforeUploadIcon($event)"
                        (onUpload)="onUploadCompletedIcon($event)">
                 </p-fileUpload>
            </div>        
        </p-accordionTab>
    </p-accordion>   
    </div>      
</div>
</form>
<p-confirmDialog header="Confirmation" key="editMemberConfirmDialog" icon="pi pi-exclamation-triangle"></p-confirmDialog> 
